import { IconButtonProps } from '@chakra-ui/react';

import { ButtonIcon } from 'shared/components/Button';

type ToolbarButtonIconProps = IconButtonProps;

export const ToolbarButtonIcon = ({
  disabled,
  ...props
}: ToolbarButtonIconProps) => {
  return <ButtonIcon variant="ghost" disabled={disabled} {...props} />;
};
